import Quiz from '@components/quiz'
import { NumberParam, useQueryParam } from 'use-query-params'
import { useQuestions } from '../../redux/quiz'

const QuizPage = () => {
  const quiz = useQuestions()
  const [step] = useQueryParam('step', NumberParam)

  return !quiz ? null : (
    <Quiz
      step={quiz[(step || 1) - 1]}
      currentStep={step || 1}
      nextStep={(step || 1) < quiz.length ? (step || 1) + 1 : null}
      previousStep={(step || 1) - 1}
      isLastStep={step === quiz.length}
      stepsCount={quiz.length}
    />
  )
}
export default QuizPage
